import React, { useEffect, useReducer, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

import { ToastType, useToast } from '../../../hooks/useToast'
import { useChangeConditionIdForPartsMutation } from '../../../modules/store/datahubApi/datahubApi'
import { partReducer } from '../../../pages/NewPart/partReducer'
import { Part, partFields, partInput, PartListSearchParams } from '../../../types/part/partTypes'
import Loader from '../../_atoms/Loader/Loader'
import OverlayWithText from '../../_atoms/OverlayWithText/OverlayWithText'
import PartCreateUpdateTable from '../PartCreateUpdateTable/PartCreateUpdateTable'

import { initialPartState } from './initialPartState'
import styles from './styles.module.scss'

interface Props {
    isOpen: boolean
    closeModal: () => void
    parts: Part[]
    confirmChanges: () => void
    partListSearchParams?: PartListSearchParams
}

export const ModalChangeCondition = ({ isOpen, closeModal, parts, confirmChanges, partListSearchParams }: Props) => {
    const [state, dispatch] = useReducer(partReducer, initialPartState)
    const [fetchChangeConditionId, { isLoading, error, data }] = useChangeConditionIdForPartsMutation()
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(false)

    const onCloseModal = () => {
        closeModal()
    }

    const getField = (fieldToSearch: partFields) =>
        state.fields.find((field: partInput) => field.field === fieldToSearch)

    const confirm = async () => {
        const conditionId: number = getField(partFields.conditionId).value

        if (conditionId) {
            fetchChangeConditionId({
                partsId: parts.map(part => part.id),
                conditionId: conditionId,
                params: partListSearchParams,
            })
        } else {
            setIsSubmitDisabled(true)
        }
    }

    const getIsSubmitDisabled = () => {
        let isDisabled = false
        state.fields.forEach((field: partInput) => {
            if (field?.specialProps?.errorMessage) {
                isDisabled = true
            }
        })
        setIsSubmitDisabled(isDisabled)
    }

    useEffect(() => {
        getIsSubmitDisabled()
    }, [getField(partFields.conditionId)?.value])

    useEffect(() => {
        if (data) {
            confirmChanges()
            closeModal()
        }
    }, [closeModal, confirmChanges, data])

    useToast({ isTriggered: !!error, type: ToastType.ERROR, message: 'Ошибка изменения состояния' })
    useToast({ isTriggered: !!data, type: ToastType.SUCCESS, message: 'Запчасти успешно обновлены' })

    return (
        <Modal show={isOpen} onHide={onCloseModal} centered dialogClassName={styles.modal}>
            {isLoading && (
                <OverlayWithText backgroundBootstrapColor={'bg-secondary'}>
                    <Loader diameterInPx={100} thicknessInPx={10} />
                </OverlayWithText>
            )}
            <Modal.Header closeButton>
                <Modal.Title>
                    <b>Изменить состояние</b>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <PartCreateUpdateTable dispatch={dispatch} fields={state.fields} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={confirm} disabled={isSubmitDisabled}>
                    Сохранить
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
